import { IconChevronDown, IconChevronUp, IconFaceIdError } from '@tabler/icons-react'
import CourseCardSkeleton from '../../../components/CourseCard/CourseCardSkeleton/CourseCardSkeleton'
import useOwnCourses from '../../../hooks/useOwnCourses'
import OwnCoursesGridGroup from '../OwnCoursesGridGroup/OwnCoursesGridGroup'
import './OwnCoursesList.css'
import { useIsMount } from '../../../hooks/useIsMount'
import { Button, Stack } from '@mantine/core'
import useOnboarding from '../../../hooks/useOnboarding'
import { TOUR_STEPS } from '../../../utils/tour'
import { useState } from 'react'
import OnBoardingBtn from '../../../components/OnBoardingBtn/OnBoardingBtn'

export default function OwnCoursesList() {
   const isMount = useIsMount()
   const {
      state,
      changeFilters,
      filters,
      groupedCourses
   } = useOwnCourses(isMount)

   const [runOnboarding, setRunOnboarding] = useState(false)
   const tour = useOnboarding({
      steps: TOUR_STEPS.ownCourses,
      disabled: (state.isLoading || state.error),
      page: 'ownCourses',
      runAgain: runOnboarding,
      lastBtnFunction: () => setRunOnboarding(false)
   })

   return (
      <section className='OwnCoursesList-container'>
         {tour}
         <OnBoardingBtn onClick={() => setRunOnboarding(true)} />
         {state.error &&
            <div className='OwnCoursesList-error-container'>
               < IconFaceIdError size={150} color='var(--color-red)' />
               <p className='OwnCoursesList-error--text'>{state.error}</p>
            </div>
         }

         {state.isLoading && < CourseCardSkeleton withTitle />}

         {(!state.error && !state.isLoading && groupedCourses.length !== 0) &&

            <>
               <Button id='OwnCoursesList--sort-button' w={'max-content'} onClick={() => changeFilters(filters.order === 'asc' ? 'des' : 'asc')}>
                  {filters.order === 'asc' ? < IconChevronUp /> : < IconChevronDown />}
                  <span>Porcentaje de avance</span>
               </Button>
             
               <Stack gap={0}>
                  {groupedCourses.map((group, idx) => (
                     <div key={group.year} style={{paddingBottom: '1.5rem',marginBottom: '1.5rem', borderBottom: groupedCourses?.length > 1 && idx !== groupedCourses?.length - 1 ? "3px solid var(--color-text-primary)" : ""}} >
                        <h3 style={{ color: "var(--color-text-primary)", fontSize: 'var(--fs-h3)' }}>AÑO {group.year}</h3>
                        <OwnCoursesGridGroup cardsToMap={group.data} />
                     </div>
                  ))}
               </Stack>
            </>
         }

         {/* sin resultados y sin errores */}
         {(!state.error && !state.isLoading && groupedCourses.length === 0) &&
            <p className='OwnCoursesList-noResults--text'>No hemos encontrado resultados</p>
         }

         {/* si se quiere filtrar por cursos finalizados */}
         {/* {(!state.error && !state.isLoading && filteredCourses.length !== 0) &&
            < OwnCoursesGridGroup title='Cursos finalizados' cardsToMap={filteredCourses} cardsWithTitle={false} bgCardColor='var(--color-secondary-light)' />
         } */}
      </section>
   )
}
